let restoring = false;

document.addEventListener('turbo:visit', ({ detail: { action } }) => {
  restoring = action === 'restore';
});

document.addEventListener('turbo:load', () => {
  if (!restoring) return;

  restoring = false;
  window.history.replaceState(window.history.state, '', window.location.href);
});
